import React from 'react';
import Card from '../../../core/layout/Card';
import Tabs from '../../../core/layout/Tabs';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import ContractListContainer from './ContractListContainer';
import ContractListFilterContainer from './ContractListFilterContainer';
import ContractActivationDialogContainer from './ContractActivationDialogContainer';
import PropTypes from 'prop-types';

const ContractListScene = (props) => {
  return (
    <>
      <Breadcrumb crumbs={[{ text: 'Contracts' }]} />
      <Card
        title="Contracts"
        actions={
          <Button
            key="new_contract"
            type="primary"
            icon="plus"
            label="New Contract"
            onClick={() =>
              browserHistory.push({
                pathname: `/contracts/new`,
                state: { from: { text: 'Contracts', pathname: '/contracts' } },
              })
            }
          />
        }
      >
        <ContractListFilterContainer />
        <Tabs
          onChange={props.onTabChange}
          tabs={[
            {
              key: 'ACTIVE',
              title: 'Active',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'BLOCKED',
              title: 'Blocked',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'CANCELED',
              title: 'Canceled',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'AWAITING_INITIAL_PAYMENT',
              title: 'Awaiting initial payment',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'AWAITING_UPGRADE_PAYMENT',
              title: 'Awaiting upgrade payment',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'AWAITING_REACTIVATE_PAYMENT',
              title: 'Awaiting reactivate payment',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'AWAITING_REACTIVATE_DOWNGRADE_PAYMENT',
              title: 'Awaiting reactivate downgrade payment',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'AWAITING_UPGRADE_START_DATE',
              title: 'Awaiting upgrade start date',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'AWAITING_DOWNGRADE_START_DATE',
              title: 'Awaiting downgrade start date',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'AWAITING_ANNUAL_RENOVATION',
              title: 'Pending annual renewal',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'AWAITING_RENOVATE_START_DATE',
              title: 'Awaiting annual renewal date',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
            {
              key: 'FREE_TRIAL',
              title: 'Free Trial',
              active: false,
              content: (
                <div style={{ width: '100%' }}>
                  <ContractListContainer />
                </div>
              ),
            },
          ]}
        />
        <ContractActivationDialogContainer />
      </Card>
    </>
  );
};

ContractListScene.propTypes = {
  onTabChange: PropTypes.func.isRequired,
};
export default ContractListScene;
